import React from 'react';
import WAITING_ICON from './../assets/images/waiting_for_accept.svg';
import WAITING_ICON_ACTIVE from './../assets/images/waiting_for_accept_active.svg';
import PAYMENT_ICON from './../assets/images/waiting_for_payment.svg';
import PAYMENT_ICON_ACTIVE from './../assets/images/waiting_for_payment_active.svg';
import PREPARE_ICON from './../assets/images/prepare_prescription.svg';
import PREPARE_ICON_ACTIVE from './../assets/images/prepare_prescription_active.svg';
import BIKER_ICON from './../assets/images/biker_in_route.svg';
import BIKER_ICON_ACTIVE from './../assets/images/biker_in_route_active.svg';
import {useDispatch, useSelector} from "react-redux";
import {getPharmacyOrders, setPharmacyActiveTile} from "../redux/actions/dashboard";
const PharmacyBottomNavigation = () => {
    const dispatch = useDispatch();
    const { pharmacy_active_tile } = useSelector(state => state.dashboard);
    let items = [
        {
            title : 'در انتظار تایید',
            key : 'vendor_assigned',
            icon : WAITING_ICON,
            active_icon : WAITING_ICON_ACTIVE
        },
        {
            title : 'در انتظار پرداخت',
            key : 'waiting_for_payment',
            icon : PAYMENT_ICON,
            active_icon : PAYMENT_ICON_ACTIVE
        },
        {
            title : 'آماده سازی',
            key : 'prepare_prescription',
            icon : PREPARE_ICON,
            active_icon : PREPARE_ICON_ACTIVE
        },
        {
            title : 'آماده تحویل',
            key : 'biker_in_route',
            icon : BIKER_ICON,
            active_icon : BIKER_ICON_ACTIVE
        }
    ];
    return (
        <>
            <div className="bottom-navigation-holder">
                {
                    items.map((item, index) => {
                        return (
                            <div className={'bottom-navigation-item-holder ' + (item.key === pharmacy_active_tile ? "active" : "")} key={index} onClick={() => {
                                dispatch(setPharmacyActiveTile(item.key))
                                dispatch(getPharmacyOrders());
                            }}>
                                <div className="icon-holder">
                                    <img src={item.key === pharmacy_active_tile ? item.active_icon : item.icon} width={20} height={20}  alt="bottom-navigation-icon"/>
                                </div>
                                <div className='title'>
                                    {item.title}
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </>
    )
};

export default PharmacyBottomNavigation;